import getUserTodoCount from '../api/get-user-todo-count';

if (window.loggedIn) getUserTodoCount();
